const getDialog = (rootState) => rootState.ws.dialogs;

export default getDialog;
